module.exports = __webpack_public_path__ + "fa-brands-400.ttf?513aa607d398efaccc559916c3431403";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/webfonts/fa-brands-400.ttf
// module id = 1450
// module chunks = 0